export enum QUERY_KEYS {
  getFarms = "FARMS_GET",
  getFarmersFields = "FARMERS_FIELDS_GET",
  getStaticProvinces = "STATIC_PROVINCES_GET",
  getStaticCities = "STATIC_CITIES_GET",
  getStaticOwnershipType = "STATIC_OWNERSHIP_TYPE",
  getStaticIrrigationSources = "STATIC_IRRIGATION_SOURCES",
  deleteFarm = "FARM_DELETE",
}
